export enum OperatorTabsEnum {
  BackOffice = "BACK_OFFICE",
  Profile = "PROFILE",
  Media = "MEDIA",
  Staff = "STAFF",
  // FeaturedIn = "FEATURED_IN",
  Events = "EVENTS",
  Activity = "ACTIVITY",
  Connections = "CONNECTIONS",
}
